import React, { Component } from "react";
import { connect } from "react-redux";

import Backdrop from "components/UI/Backdrop/Backdrop";
import Aux from "hoc/ReactAux/ReactAux";
import FieldError from "components/UI/FieldError";
import { checkValidity } from "../../../shared/utility";
import * as actions from "actions/index";
import "./RegisterCompany.css";

class RegisterCompany extends Component {
  state = {
    formIsValid: false,
    registerCompanyForm: {
      senderNameFrom: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      company: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      numberOfEmployees: {
        value: 0,
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      senderLastNameFrom: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      emailFrom: {
        value: "",
        validation: {
          required: true,
          email: true
        },
        valid: false,
        touched: false
      },
      phone: {
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      }
    }
  };

  isInvalid = name => {
    const field = this.state.registerCompanyForm[name];
    return !field.valid && field.touched;
  };

  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.onToggleRegisterCompany(false);
    }
  };

  handleSendEmail = () => {
    const payload = {};

    for (let formElementIndentifier in this.state.registerCompanyForm) {
      payload[formElementIndentifier] = this.state.registerCompanyForm[
        formElementIndentifier
      ].value;
    }
    this.props.onSendEmailToRegisterCompany(payload);
    this.setState({ showModal: true });
  };

  handleInputs = event => {
    let updateRegisterCompanyForm = {
      ...this.state.registerCompanyForm
    };

    let updateFormElement = {
      ...updateRegisterCompanyForm[event.target.name]
    };

    updateFormElement.value = event.target.value;

    updateFormElement.valid = checkValidity(
      updateFormElement.value,
      updateFormElement.validation
    );
    updateFormElement.touched = true;

    updateRegisterCompanyForm[event.target.name] = updateFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updateRegisterCompanyForm) {
      formIsValid =
        updateRegisterCompanyForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      registerCompanyForm: updateRegisterCompanyForm,
      formIsValid: formIsValid
    });
  };

  render() {
    let registerCompany = null;
    if (this.props.showRegisterCompany) {
      let disable = {
        cursor: "pointer"
      };

      if (!this.state.formIsValid) {
        disable = {
          background: "var(--lt-color-muted)",
          color: "var(--lt-color-muted-foreground)",
          border: "1px solid var(--lt-color-border)",
          cursor: "not-allowed"
        };
      }

      registerCompany = (
        <Aux>
          <Backdrop show={true} />
          <div className="overlay connected">
            <div className="overlay-box">
              <button
                onClick={() => this.props.onToggleRegisterCompany(false)}
                type="button"
                className="bt-close mfp-close lb-fechar fa fa-times"
              />
              <h5>
                Please complete the form below to be connected with a lunch
                specialist
              </h5>
              <form>
                <div className="w-48 left">
                  <label>Name</label>
                  <input
                    tabIndex="1"
                    type="text"
                    name="senderNameFrom"
                    className={this.isInvalid("senderNameFrom") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("senderNameFrom")}
                    aria-describedby={this.isInvalid("senderNameFrom") ? "senderNameFrom-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="senderNameFrom-error" show={this.isInvalid("senderNameFrom")}>
                    Enter your first name.
                  </FieldError>
                  <label>Company Name</label>
                  <input
                    tabIndex="3"
                    type="text"
                    name="company"
                    className={this.isInvalid("company") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("company")}
                    aria-describedby={this.isInvalid("company") ? "company-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="company-error" show={this.isInvalid("company")}>
                    Enter your company name.
                  </FieldError>
                  <label>Number of Employees</label>
                  <input
                    tabIndex="5"
                    type="number"
                    name="numberOfEmployees"
                    className={this.isInvalid("numberOfEmployees") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("numberOfEmployees")}
                    aria-describedby={this.isInvalid("numberOfEmployees") ? "numberOfEmployees-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="numberOfEmployees-error" show={this.isInvalid("numberOfEmployees")}>
                    Enter the number of employees.
                  </FieldError>
                </div>
                <div className="w-48 right">
                  <label>Last Name</label>
                  <input
                    tabIndex="2"
                    type="text"
                    name="senderLastNameFrom"
                    className={this.isInvalid("senderLastNameFrom") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("senderLastNameFrom")}
                    aria-describedby={this.isInvalid("senderLastNameFrom") ? "senderLastNameFrom-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="senderLastNameFrom-error" show={this.isInvalid("senderLastNameFrom")}>
                    Enter your last name.
                  </FieldError>
                  <label>Email</label>
                  <input
                    tabIndex="4"
                    type="email"
                    name="emailFrom"
                    className={this.isInvalid("emailFrom") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("emailFrom")}
                    aria-describedby={this.isInvalid("emailFrom") ? "emailFrom-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="emailFrom-error" show={this.isInvalid("emailFrom")}>
                    Enter a valid email address.
                  </FieldError>
                  <label>Phone</label>
                  <input
                    tabIndex="6"
                    type="number"
                    name="phone"
                    className={this.isInvalid("phone") ? "Invalid" : null}
                    aria-invalid={this.isInvalid("phone")}
                    aria-describedby={this.isInvalid("phone") ? "phone-error" : undefined}
                    onChange={this.handleInputs}
                  />
                  <FieldError id="phone-error" show={this.isInvalid("phone")}>
                    Enter your phone number.
                  </FieldError>
                </div>
              </form>
              <a
                disabled={!this.state.formIsValid}
                style={disable}
                onClick={this.handleSendEmail}
                className="bt"
              >
                Send
              </a>
            </div>
          </div>
        </Aux>
      );
    }

    return registerCompany;
  }
}

const mapStateToProps = state => {
  return {
    showRegisterCompany: state.landingReducer.showRegisterCompany
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onToggleRegisterCompany: toggle =>
      dispatch(actions.toggleRegisterCompany(toggle)),
    onSendEmailToRegisterCompany: payload =>
      dispatch(actions.sendEmailToRegisterCompany(payload))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterCompany);



// WEBPACK FOOTER //
// ./src/containers/Landing/RegisterCompany/index.js